import type { CSSProperties } from "react";

interface BrandIconProps {
  size: number;
}

const iconStyle: CSSProperties = {
  display: "block",
  filter: "var(--exms-brand-icon-filter)",
};

export function BrandIconFilterDefinition() {
  return (
    <svg width="0" height="0" aria-hidden="true" focusable="false" style={{ position: "absolute" }}>
      <defs>
        <filter
          id="exms-dark-brand-icon"
          colorInterpolationFilters="sRGB"
          x="-5%"
          y="-5%"
          width="110%"
          height="110%"
        >
          <feColorMatrix
            result="transparentDarkMark"
            type="matrix"
            values="
              0 0 0 0 0.658824
              0 0 0 0 0.647059
              0 0 0 0 1
              -1.7 0 0 0 1.7
            "
          />
          <feComposite in="transparentDarkMark" in2="SourceAlpha" operator="in" />
        </filter>
      </defs>
    </svg>
  );
}

export default function BrandIcon({ size }: BrandIconProps) {
  return (
    <span
      aria-hidden="true"
      style={{ display: "inline-flex", width: size, height: size, flex: "0 0 auto" }}
    >
      <img src="/favicon.svg" alt="" width={size} height={size} style={iconStyle} />
    </span>
  );
}
